export default __webpack_public_path__ + "static/media/img12.e2374684.png";